export default __webpack_public_path__ + "static/media/Right_arrowblack.64ea277b.svg";